import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
  path: '/threePartyBusiness',
  name: ' threePartyBusiness',
  meta: {
    title: '三方业务管理',
    keepAlive: false
  },
  component: Layout,
  redirect: '/threePartyBusiness/index',
  children: [
    {
      path: 'index',
      name: 'indexBusiness',
      meta: {
        title: '试题列表',
        keepAlive: false
      },
      component: resolve => require(['@/views/threePartyBusiness/Index.vue'], resolve),
    },
    {
      path: 'index',
      meta: {
        title: '试题列表',
        keepAlive: false
      },
      component: Empty,
      children: [{
        path: 'businessRadioTestA1',
        name: 'businessRadioTestA1',
        meta: {
          title: '编辑试题',
          keepAlive: false
        },
        component: resolve => require(['@/views/threePartyBusiness/components/businessRadioTestA1.vue'], resolve),

      },{
        path: 'businessRadioTestA3',
        name: 'businessRadioTestA3',
        meta: {
          title: '编辑试题',
          keepAlive: false
        },
        component: resolve => require(['@/views/threePartyBusiness/components/businessRadioTestA3.vue'], resolve),

      },
        {
          path: 'businessRadioTestB',
          name: 'businessRadioTestB',
          meta: {
            title: '编辑试题',
            keepAlive: false
          },
          component: resolve => require(['@/views/threePartyBusiness/components/businessRadioTestB.vue'], resolve),

        },
        {
          path: 'businessCheckedTestA1',
          name: 'businessCheckedTestA1',
          meta: {
            title: '编辑试题',
            keepAlive: false
          },
          component: resolve => require(['@/views/threePartyBusiness/components/businessCheckedTestA1.vue'], resolve),

        },
        {
          path: 'businessCheckedTestA4',
          name: 'businessCheckedTestA4',
          meta: {
            title: '编辑试题',
            keepAlive: false
          },
          component: resolve => require(['@/views/threePartyBusiness/components/businessCheckedTestA4.vue'], resolve),

        }
      ]
    }
  ]
}


